export const STATS = 'stats/web'
